import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ProblemDetail } from '@core/models';
import { Observable, interval, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { UiState } from '@ngxs-store/ui-store/ui.state';

@Component({
  selector: 'app-problem-detail-snackbar',
  templateUrl: './problem-detail-snackbar.component.html',
  styleUrls: ['./problem-detail-snackbar.component.scss']
})
export class ProblemDetailSnackbarComponent implements OnInit {
  isMobileMode = false;
  snackbarSelected = false;
  interval$: Observable<number>;

  constructor(
    private store: Store,
    private snackBarRef: MatSnackBarRef<ProblemDetailSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { problemDetail: ProblemDetail }) { }

  ngOnInit() {

    this.isMobileMode = this.store.selectSnapshot(UiState.getIsMobileMode);

    this.interval$ = interval(50).pipe(
      map((i) => {
        if (i === 100) {
          if (!this.snackbarSelected) {
            this.snackBarRef.dismiss();
          }
        }

        return i;
      })
    );
  }

  select() {
    if (!this.isMobileMode) {
      this.snackbarSelected = true;
      this.interval$ = of(100);
    }
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
